import { Component, Input, OnInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CvConfigurationService } from '../services/cv-configuration.service';

@Component({
  selector: 'cv-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {

  @Input() title: string;
  @Input() body: string | string[];
  @Input() isCXone: boolean;
  @Input() isInnerHtml: boolean;
  /*
Type of dialogs:
  1. Warning dialog
  2. Error dialog
  3. Success dialog
  4. Alternative Warning dialog
  11. Cxone Warning dialog
  12. Cxone Error dialog
*/
  @Input() dialogType: number;
  @Input() cancelButtonText: string;
  @Input() confirmButtonText: string;

  @Input() customModalClass: string;

  iconDialogHref: any;
  iconStyle: string;
  iconCloseHref: any;
  buttonCancelClass: string;
  buttonConfirmClass: string;
  footerBorderColorClass: string = '';
  isLoadingStyles: boolean = true;
  safeBodyHtml: SafeHtml = "";
  sanitizedArray: SafeHtml[] = [];
  isArray: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    if (this.isCXone) {
      this.loadCxoneElements();
    } else {

    }
  }

  loadCxoneElements(): void {
    this.loadIconCxone();
    this.loadCxoneButtons();

    // Force the change detection to update the view
    this.cdRef.detectChanges();

    const element = document.querySelector('.modal-dialog > .modal-content > cv-custom-dialog > .cxone-custom-dialog');
    const alert = document.querySelector('.modal-dialog > .modal-content > cv-custom-dialog > .modal-alert');

      if (element) {
        let modalDialog = element.closest('.modal-content') as HTMLElement;
        if (modalDialog) {
          modalDialog.style.paddingLeft = '0';
          modalDialog.style.paddingRight = '0';
        }
      }

    if (alert) {
      const modalContent = alert.closest('.modal-content') as HTMLElement;
      if (modalContent) {
        modalContent.style.paddingLeft = '0';
        modalContent.style.paddingRight = '0';
      }
    }
    this.isLoadingStyles = false;

    if (this.isInnerHtml) {
      if (Array.isArray(this.body)) {
        this.isArray = true;
        this.sanitizeArray(this.body as string[]);
      } else {
        this.safeBodyHtml = this.sanitizer.bypassSecurityTrustHtml(this.body);
      }
    }
  }

  loadIconCxone(): void {
    switch (this.dialogType) {
      case 1:
        this.iconStyle = 'icon-20 mr-2 mb-1 fill-warningYellow';
        this.iconDialogHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/warning-no-longer-available.svg#warning-no-longer-available">
        </use>`);
        this.iconCloseHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/close.svg#close">
        </use>`);
        break;
      case 2:
        this.iconStyle = 'icon-20 mr-2 fill-errorRed';
        this.footerBorderColorClass = 'border-errorRed';
            this.iconDialogHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/gamification/alert-off.svg#alert-off">
          </use>`);
        this.iconCloseHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/close.svg#close">
          </use>`);
         break;
       case 4:
         this.iconStyle = 'icon-20 mr-2 fill-warningYellow';
         this.iconDialogHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/modal-warning.svg#modal-warning">
          </use>`);
         this.iconCloseHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/close.svg#close">
         </use>`);
         break;
      case 12:
        this.iconStyle = 'icon-20 mr-2 fill-errorRed';
        this.footerBorderColorClass = 'border-errorRed';
            this.iconDialogHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/gamification/alert.svg#alert">
          </use>`);
        this.iconCloseHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/close.svg#close">
          </use>`);
         break;
      case 11:
      case 13:
      default:
        this.iconStyle = 'icon-20 mr-2 mb-1 fill-warningYellow';
        this.iconDialogHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/warning-no-longer-available.svg#warning-no-longer-available">
        </use>`);
        this.iconCloseHref = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/close.svg#close">
        </use>`);
        break;
    }


  }

  loadCxoneButtons(): void {
    switch (this.dialogType) {
      case 1:
        this.buttonConfirmClass = 'btn btn-primary confirm-text text-no-wrap btn-width px-1';
        this.buttonCancelClass = 'btn btn-secondary cancel-text p-0';
        break;
      case 2:
        this.buttonConfirmClass = 'btn btn-primary confirm-text';
        this.buttonCancelClass = 'btn btn-secondary cancel-text';
        break;
      default:
        this.buttonConfirmClass = 'btn btn-primary confirm-text';
        this.buttonCancelClass = 'btn btn-secondary cancel-text';
        break;
    }
  }

  sanitizeArray(strings: string[]): void {
    this.sanitizedArray = strings.map(str => this.sanitizer.bypassSecurityTrustHtml(str));
  }

}
